import { useLanguageStore } from '@/store/languageStore';
import { Button } from './ui/button';

interface LanguageSwitcherProps {
  variant?: 'full' | 'compact';
}

export const LanguageSwitcher = ({ variant = 'full' }: LanguageSwitcherProps) => {
  const { language, setLanguage } = useLanguageStore();

  const handleLanguageChange = (lang: string) => {
    setLanguage(lang);
  };

  if (variant === 'compact') {
    return (
      <div className="flex items-center gap-1 bg-[var(--color-neutral-100)] rounded-md p-1">
        <Button
          variant={language === 'en' ? 'default' : 'ghost'}
          size="sm"
          onClick={() => handleLanguageChange('en')}
          className={`px-2 py-1 text-xs font-medium ${
            language === 'en'
              ? 'bg-primary text-primary-foreground'
              : 'text-[var(--color-neutral-600)] hover:text-[var(--color-neutral-900)] hover:bg-[var(--color-neutral-200)]'
          }`}
        >
          EN
        </Button>
        <Button
          variant={language === 'fr' ? 'default' : 'ghost'}
          size="sm"
          onClick={() => handleLanguageChange('fr')}
          className={`px-2 py-1 text-xs font-medium ${
            language === 'fr'
              ? 'bg-primary text-primary-foreground'
              : 'text-[var(--color-neutral-600)] hover:text-[var(--color-neutral-900)] hover:bg-[var(--color-neutral-200)]'
          }`}
        >
          FR
        </Button>
      </div>
    );
  }

  return (
    <div className="flex gap-2">
      <Button
        variant={language === 'en' ? 'default' : 'outline'}
        size="sm"
        onClick={() => handleLanguageChange('en')}
        className={`flex-1 ${
          language === 'en'
            ? 'bg-primary text-primary-foreground'
            : 'text-[var(--color-neutral-700)] hover:text-[var(--color-neutral-900)] hover:bg-[var(--color-neutral-100)]'
        }`}
      >
        English
      </Button>
      <Button
        variant={language === 'fr' ? 'default' : 'outline'}
        size="sm"
        onClick={() => handleLanguageChange('fr')}
        className={`flex-1 ${
          language === 'fr'
            ? 'bg-primary text-primary-foreground'
            : 'text-[var(--color-neutral-700)] hover:text-[var(--color-neutral-900)] hover:bg-[var(--color-neutral-100)]'
        }`}
      >
        Français
      </Button>
    </div>
  );
};
